import type sv from '../sv/tasks'

const tasks: typeof sv = {
  priority: {
    low: 'Low',
    normal: 'Normal',
    high: 'High',
  },
  board: {
    column: {
      todo: 'To do',
      inProgress: 'In progress',
      review: 'Review',
      done: 'Done',
    },
    syncing: 'Syncing tasks...',
    addTask: 'New task',
  },
  fields: {
    title: 'Title',
    titlePlaceholder: 'Task title...',
    description: 'Description',
    describePlaceholder: 'Describe the task...',
    addDescriptionPlaceholder: 'Add a description...',
    priority: 'Priority',
    assign: 'Assign',
    assignees: 'Assignees',
    assigneePlaceholder: 'Pick a person...',
    noAssignee: 'Nobody',
    board: 'Board',
    dueDate: 'Due date',
    pickDate: 'Pick a date...',
    clearDueDate: 'Clear due date',
    tags: 'Tags',
    tagPlaceholder: 'Add a tag and press Enter...',
    removeTag: 'Remove tag {{tag}}',
    subtasks: 'Subtasks',
  },
  create: {
    title: 'New task',
  },
  panel: {
    newTask: 'New task',
    task: 'Task',
    details: 'Task details',
    close: 'Close',
    expand: 'Expand panel',
    collapse: 'Collapse panel',
    attachments: 'Attachments ({{count}})',
    documents: 'Documents',
    upload: 'Upload',
    download: 'Download',
    openDocument: 'Open document',
    deleteAttachment: 'Delete attachment',
    sourceChats: 'Source chats ({{count}})',
    newChat: 'New chat',
    comments: 'Comments ({{count}})',
    commentPlaceholder: 'Write a comment...',
    send: 'Send',
    deleteComment: 'Delete comment',
    confirmDelete: 'Delete this task?',
    confirmDeleteYes: 'Yes, delete',
    deleteTask: 'Delete task',
    cancel: 'Cancel',
    create: 'Create',
  },
  assignee: {
    placeholder: 'Assign...',
    selected_one: '{{count}} assignee',
    selected_other: '{{count}} assignees',
    search: 'Search people...',
    noMatches: 'No matches',
  },
  subtasks: {
    progress: '{{completed}}/{{total}} done',
    assign: 'Assign',
    none: 'Nobody',
    addPlaceholder: 'Add a subtask...',
    delete: 'Delete subtask',
  },
}

export default tasks
